import React from 'react'
import DateRangeIcon from '@mui/icons-material/DateRange'

import { Typography } from '@material-ui/core'
import { Button } from '@mui/material'

function LabelFilter({ value, ...props }) {
  return (
    <Button sx={{ color: '#00AEEF', textTransform: 'none', width: 'max-content' }} variant="text" {...props}>
      <DateRangeIcon role="img" sx={{ marginRight: '8px' }} />
      <Typography variant="body2">{value}</Typography>
    </Button>
  )
}

export default LabelFilter
